import React from 'react';
import ProtectedPageSidebar from '../../components/Sidebar/ProtectedPageSidebar';
import { Content } from '../../components/Content';

export const Chat = () => {
  return (
    <Content>
      <ProtectedPageSidebar />
      <h1>Chat page</h1>
    </Content>
  );
};
